import React, {FC, useEffect, useState} from "react";
import AppUtil from "../../util/AppUtil";
import AppConstants from "../../util/AppConstants";
import GatewayService from "../../service/GatewayService";
import {DropDownCompNumber, DropDownCompString, getKeyVal, getKeyValArray} from "../util/DropDownComp";
import {DeepCombo} from "../../models/DeepCombo";
import {DeepCombosComp, DeepHead} from "./opp/DeepComboHelper";
import { useChain } from "../../context/ChainContext";

interface Props {
}
export const DeepOppComponent:FC<Props> = (props) => {
    const [deepCombos, setDeepCombos] = useState<Array<DeepCombo>>([]);
    const [maxProfit, setMaxProfit] = useState(-1);
    const [type, setType] = useState("");
    const [expiry, setExpiry] = useState(-1);
    const { chain, setChain } = useChain();
    const [sorter, setSorter] = useState(()=>(a:any, b:any)=>1)
    useEffect(()=>{
        refresh()
    }, [])

    useEffect(()=>{

    }, [type, expiry, type])

    function filter(deepCombo:DeepCombo):boolean{
        return (type=="" || type==deepCombo.type) &&
            (deepCombo.maxProfit>maxProfit || maxProfit==-1) &&
            (deepCombo.name==chain||chain==="") &&
            (deepCombo.expiry===expiry || expiry===-1)
    }

    let optimisedCombos = deepCombos
        .filter(filter)
        .sort(sorter)

    function refresh() {
        GatewayService.getDeepOpportunity().then(it=>{
            it.sort((a,b)=>-a.maxProfit*a.qty + b.maxProfit*b.qty)
            setDeepCombos(it)
        })
    }

    function getNames(){
        let set =  new Set(deepCombos.map(it=>it.name))
        return Array.from(set.values())
    }

    function getExpires(isBuy:boolean = false){
        let set =  new Set(optimisedCombos.map(it=>it.expiry))
        return getKeyValArray(Array.from(set.values()), (it)=> AppUtil.getTime(it))
    }

    function getTimes(){
        return getKeyValArray([AppConstants.DAY, AppConstants.WEEK, AppConstants.MONTH, AppConstants.YEAR], (it)=> (it/AppConstants.DAY).toString())
    }

    function set(func:(a:any, b:any)=>number) {
        setSorter(()=>func)
    }

    return<>
        <div className={"tab"}>chain = <input type="text" value={chain} onChange={event => setChain(event.target.value)}/></div>
        <div className={"tab"}>max profit = <input type="number" value={maxProfit} onChange={event => setMaxProfit(parseFloat(event.target.value))}/></div>
        <DropDownCompString text={"select type"} actual={type} arr={getKeyVal(AppConstants.deepComboTypes)} set={setType}/>
        <DropDownCompNumber text={"select expiry"} actual={expiry} arr={getExpires(true)} set={setExpiry}/>
        <DropDownCompNumber text={"max time"} actual={expiry} arr={getTimes()} set={setExpiry}/>
        <button onClick={()=>refresh()}>refresh</button>
        <table className={"full"}>
            <DeepHead func={set}/>
            <tbody>
            {optimisedCombos.map(option => <DeepCombosComp key={option.id}{...option}/>)}
            </tbody>
        </table>
    </>
}

// export default OptionOppComponent